function ready() {
  document.getElementById('menu-toggle').addEventListener('click', function(e) {
    e.preventDefault();
    document.getElementById('wrapper').classList.toggle('toggled');
  });
}

document.addEventListener('DOMContentLoaded', ready);
